import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import CTA from '../components/CTA';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  useEffect(() => {
    document.title = 'Soshniti Legal - Expert Legal Solutions for Your Business';
  }, []);

  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;